import { render, staticRenderFns } from "./mainHeader.vue?vue&type=template&id=116a19f9&scoped=true&"
import script from "./mainHeader.vue?vue&type=script&lang=ts&"
export * from "./mainHeader.vue?vue&type=script&lang=ts&"
import style0 from "./mainHeader.vue?vue&type=style&index=0&id=116a19f9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116a19f9",
  null
  
)

export default component.exports